import {useState} from "react";
import TextareaAutosize from "react-textarea-autosize";
import {ReactComponent as ServerScriptIcon} from "assets/image/Layout/ObjectPanel/ScriptTab/ic_server_script.svg";
import {ReactComponent as ClientScriptIcon} from "assets/image/Layout/ObjectPanel/ScriptTab/ic_client_script.svg";
import styles from "./index.module.scss";
import SelectDropDown from "components/Common/Dropdown/SelectDropDown";

const ScriptInput = ({name, index, value, onClickEdit, onClickRemove, textOnChange, inputOnFocus, isNewScript}) => {
  const [menuOpened, setMenuOpened] = useState(false);
  const [isRenaming, setIsRenaming] = useState(isNewScript);
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = e => {
    const {name, value} = e.target;
    setInputValue(value);
    textOnChange(e);
  };

  const handleMenuOpen = () => {
    setMenuOpened(!menuOpened);
  };

  const startRenaming = () => setIsRenaming(true);
  const stopRenaming = () => setIsRenaming(false);

  return (
    <div className={styles.container}>
      <div className={styles.script_icon}>{name === "ServerScriptTitle" ? <ServerScriptIcon /> : <ClientScriptIcon />}</div>
      {isRenaming ? (
        <TextareaAutosize
          spellCheck={false}
          className={`${styles.script_title} ${styles.renaming}`}
          name={name}
          value={inputValue}
          autoFocus={true}
          onChange={handleInputChange}
          onFocus={() => inputOnFocus(index)}
          onBlur={stopRenaming}
          placeholder={"Enter ScriptName"}
        />
      ) : (
        <div className={styles.script_title} onDoubleClick={startRenaming}>
          {value}
        </div>
      )}
      <div className={`${menuOpened ? styles.more_btn_on : styles.more_btn}`} onClick={handleMenuOpen}>
        {menuOpened && (
          <SelectDropDown style={{width: "152px", top: "-138px"}} closeDropDown={() => setMenuOpened(false)}>
            <div
              onClick={() => {
                setMenuOpened(false);
                onClickEdit();
              }}
            >
              Open
            </div>
            <div
              onClick={() => {
                setMenuOpened(false);
                startRenaming();
              }}
            >
              Rename
            </div>
            <div
              onClick={() => {
                setMenuOpened(false);
                onClickRemove();
              }}
              style={{color: "#FF828C"}}
            >
              Delete
            </div>
          </SelectDropDown>
        )}
      </div>
    </div>
  );
};

export default ScriptInput;
